import { useState } from "react";
import { Link } from "react-router-dom";
import "./header.css";
import logo from "../assets/logo.webp";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [logoSrc, setLogoSrc] = useState(logo);
  const fallbackLogo = `${process.env.PUBLIC_URL}/logo192.png`;
  const closeMenu = () => setOpen(false);
  const handleLogoError = () => {
    if (logoSrc !== fallbackLogo) {
      setLogoSrc(fallbackLogo);
    }
  };

  const toggleMenu = () => {
    console.log('Hamburger clicked! Current state:', open);
    setOpen(!open);
  };

  return (
    <header className="header">
      <div className="header-inner">

        {/* LEFT */}
        <div className="header-left">
          <a
            href="https://wa.me/96550743312"
            target="_blank"
            rel="noopener noreferrer"
            className="add-btn"
          >
            + أضف شاليهك
          </a>

          <button
            className="hamburger"
            aria-label="Open menu"
            onClick={toggleMenu}
          >
            ☰
          </button>
        </div>

        {/* CENTER NAV */}
        <nav className={`header-nav ${open ? "open" : ""}`}>
          <Link to="/" onClick={closeMenu}>الرئيسية</Link>
          <Link to="/about" onClick={closeMenu}>من نحن</Link>
          <Link to="/contact" onClick={closeMenu}>اتصل بنا</Link>

          {/* Mobile only */}
          <a
            href="https://wa.me/96550743312"
            target="_blank"
            rel="noopener noreferrer"
            className="add-btn-mobile"
            onClick={closeMenu}
          >
            + أضف شاليهك
          </a>
        </nav>

        {/* RIGHT */}
        <div className="header-right">
          <img
            src={logoSrc}
            alt="YShaleh Logo"
            className="logo"
            width="160"
            height="160"
            fetchPriority="high"
            decoding="async"
            onError={handleLogoError}
          />
        </div>

      </div>
    </header>
  );
}
